import {PROVIDER_FLAGS} from '@Constants/index.constants.js';

export const ViewProposalState = {
	url: '/proposal/:customerToken/:serviceProviderId/:consultationId/:proposalId?showBack',
	title: 'View Presented Proposal',
	params: {
		customerToken: null,
		serviceProviderId: null,
		consultationId: null,
		proposalId: null,
		showBack: null,
	},
	templateProvider: [
		'providerFlags',
		providerFlags =>
			providerFlags?.[PROVIDER_FLAGS.PRESENTATION_V2]
				? '<view-proposal-v2 provider-flags="$resolve.providerFlags"></view-proposal-v2>'
				: '<view-proposal provider-flags="$resolve.providerFlags"></view-proposal>',
	],
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		const RoutesSvc = $transition$.injector().get('RoutesResolveSvc');
		return (
			RoutesSvc.getPresentationFlags({trans: $transition$})
				// a failed lookup imports the production page; the providerFlags resolve below
				// reports the failure, so it is not swallowed here
				.catch(() => ({}))
				.then(flags =>
					flags?.[PROVIDER_FLAGS.PRESENTATION_V2]
						? import(
								/* webpackChunkName: "viewProposalV2Mod" */
								'@Containers/view-proposal-page/view-proposal-v2.cmp.js'
							)
						: import(
								/* webpackChunkName: "viewProposalMod" */
								'@Containers/view-proposal-page/view-proposal.cmp.js'
							)
				)
				.then(res => $ocLazyLoad.load({name: res.default}))
				.catch(err => $log.error(err))
		);
	},
	resolve: [
		{
			token: 'canView',
			policy: {when: 'EAGER'},
			deps: ['RoutesResolveSvc', '$transition$'],
			resolveFn: (RoutesSvc, trans) =>
				RoutesSvc.validateConsultationPublic({status: 'presented', ...trans.params()}).catch(state =>
					trans.router.stateService.go(state.name, state.params)
				),
		},
		{
			token: 'providerFlags',
			policy: {when: 'LAZY'},
			deps: ['RoutesResolveSvc', '$transition$'],
			resolveFn: (RoutesSvc, trans) => RoutesSvc.getPresentationFlags({trans}),
		},
	],
};
